import { TimeRange } from "../../components/Dashboard/DoctorDashboard/views/one-one-sessions/contexts/CalendarTimeContext";
import { fetchOrchidAPI } from "utils/api";
import { getErrorDetail } from "components/utility/utils";

/**
 * Query unavailability among the week
 * @param start weekly start date
 * @param end weekly end date
 * @param onBehalfOf optional user ID to query blocked intervals on behalf of a specific user
 */
export default async function queryBlockedIntervals(
  [start, end]: TimeRange,
  onBehalfOf?: string,
): Promise<BlockedInterval[]> {
  // sanity check
  if (!start || !end) {
    return [];
  }

  const res = await fetchOrchidAPI(
    `/api/scheduler/v1/unavailability/?datetime_start=${new Date(
      start,
    ).toISOString()}&datetime_end=${new Date(end).toISOString()}${
      onBehalfOf ? `&on_behalf_of=${onBehalfOf}` : ""
    }`,
  );
  if (!res.ok) {
    throw new Error(getErrorDetail(await res.text()));
  }

  return (await res.json()).map((e: Record<string, string>) => {
    return {
      ...e,
      start: new Date(e.start).toISOString(),
      end: new Date(e.end).toISOString(),
    };
  });
}
